import App from '../../../app/browser/App';
// eslint-disable-next-line import/first
import createRoutes from 'account-ion/lib/modules/office/browser/routes/routes';

export default createRoutes(App);



// WEBPACK FOOTER //
// ./src/modules/account-ion/browser/createRoutes.js